import { IApplicationState, INextAction } from '@bridebook/web/lib/types';

export const selectNextAction = (
  state: IApplicationState,
  type: INextAction['type'],
  id: INextAction['id'],
) => {
  const nextAction = state.ui.nextAction;
  if (nextAction?.type !== type || nextAction?.id !== id) return undefined;

  return nextAction;
};

export const getIsLostLeadModalVisible = (state: IApplicationState) => state.ui.lostLeadModal.show;
export const getLostLeadModalSupplierId = (state: IApplicationState) =>
  state.ui.lostLeadModal.supplierId;

export const getIsShowroundPromoModalVisible = (state: IApplicationState) =>
  state.ui.showroundPromoModal.isVisible;
export const getShowroundPromoModalSupplierId = (state: IApplicationState) =>
  state.ui.showroundPromoModal.supplierId;
export const getShowroundPromoModalActionLocationAnalytics = (state: IApplicationState) =>
  state.ui.showroundPromoModal.actionLocationAnalytics;
export const getMobileNavShown = (state: IApplicationState) => state.ui.mobileNavShown;
export const getStickyBottomBarShown = (state: IApplicationState) =>
  state.ui.stickyBottomBarsShown > 0;

export const getIsRatingModalVisible = (state: IApplicationState) => state.ui.isRatingModalVisible;

export const getIsCalendlyModalVisible = (state: IApplicationState) =>
  state.ui.isCalendlyModalVisible;

export const getIsPushNotificationOptInVisible = (state: IApplicationState) =>
  state.ui.pushNotificationOptInShown;

export const getPushNotificationOptInVariant = (state: IApplicationState) =>
  state.ui.pushNotificationOptInVariant;

// Download App Banner
export const getDownloadAppBanner = (state: IApplicationState) => state.ui.downloadAppBanner;
export const getDownloadAppBannerHeight = (state: IApplicationState) =>
  state.ui?.downloadAppBanner?.height || 0;

export const getSpecialOfferPopupOffer = (state: IApplicationState) =>
  state.ui.specialOfferPopupOffer;
export const getSpecialOfferPopupType = (state: IApplicationState) =>
  state.ui.specialOfferPopupType;

// CSAT Feedback
export const getIsCsatFeedbackOpen = (state: IApplicationState) => state.ui.csatFeedbackOpen;
